import { gql } from '@apollo/client';

export const GET_INSTITUTIONS = gql`
  query GetInstitutions($institutionIds: [String!]!) {
    institutions(institutionIds: $institutionIds) {
      institutionId
      institutionName
      city
      state
      isSubS
      institutionType
    }
  }
`;

